import React, { useState } from "react";
import { observer } from "mobx-react";
import Button from "ui/Button/Button";
import Counter from "common/Counter/Counter";
import { useStore } from "store";
import { cn } from "helpers/style";
import styles from "./AddToCart.module.scss";
import AddToCartModalWithPrices from "./components/AddToCartModalWithPrices/AddToCartModalWithPrices";

type Props = {
  product: Entity.Product;
  price: Entity.Product.Price;
  size?: "small" | "large";
  counterSize?: "small" | "large";
  analyticsMeta?: {
    position: number;
    list: string;
  };
  counterWide?: boolean;
  hideCartToast?: boolean;
  onAddProduct?: () => void;
  text?: string;
  showExpiringPrices?: boolean;
  showOnlyButton?: boolean;
  className?: string;
};

const AddToCart: React.FC<Props> = ({
  product,
  size,
  counterSize,
  analyticsMeta,
  hideCartToast,
  counterWide = false,
  onAddProduct,
  text = "В корзину",
  price,
  showExpiringPrices,
  showOnlyButton = false,
  className,
}: Props) => {
  const { cart, notifications, user } = useStore();
  const [submitting, setSubmitting] = useState(false);
  const itemInCart = cart.get(product.id, price);

  async function addToCart() {
    if (user.isEmployeeMode && !showExpiringPrices) {
      notifications.show({
        type: "modal",
        component: AddToCartModalWithPrices,
        props: {
          product,
        },
      });
    } else {
      if (!submitting) {
        setSubmitting(true);
        try {
          await cart.add(product, price, 1, analyticsMeta, hideCartToast);
          onAddProduct && onAddProduct();
        } finally {
          setSubmitting(false);
        }
      }
    }
  }

  async function handleChangeCount(quantity) {
    if (!submitting) {
      setSubmitting(true);
      try {
        await cart.setItemCount(itemInCart, quantity);
      } finally {
        setSubmitting(false);
      }
    }
  }

  return (
    <div
      className={cn([
        styles.addToCart,
        size === "large" && styles.addToCartLarge,
        className,
      ])}
      onClick={event => event.preventDefault()}
    >
      {(!itemInCart || showOnlyButton) && (
        <Button orange fluid onClick={addToCart}>
          {text}
        </Button>
      )}

      {itemInCart && !showOnlyButton && (
        <Counter
          value={itemInCart.quantity}
          onChange={handleChangeCount}
          size={counterSize}
          wide={counterWide}
          disabled={submitting}
          max={price.maxQuantity}
        />
      )}
    </div>
  );
};

export default observer(AddToCart);
